import React from 'react'

const CtaBand = () => (
  <section className="vt-section">
    <div className="vt-shell">
      <div className="ctaband">
        <h2>Du patient à la prescription, aujourd'hui.</h2>
        <p>Essai gratuit de 30 jours pour les vétérinaires en exercice. Sans carte bancaire.</p>
        <div className="cta-buttons">
          <a className="vt-btn vt-btn-lg vt-btn-ghost-white" href="https://app.fetchy.vet">
            Démarrer l'essai gratuit
          </a>
          <a className="vt-btn vt-btn-lg vt-btn-ghost-light" href="#contact">
            Nous contacter
          </a>
        </div>
      </div>
    </div>
  </section>
)

export default CtaBand
